import { motion } from 'framer-motion'
import { Lock, ArrowRight, ShieldCheck, Database, Key } from 'lucide-react'

export function SecuritySection() {
  const steps = [
    { icon: Key, label: 'GitHub Auth' },
    { icon: Database, label: 'Encrypted Credential' },
    { icon: ShieldCheck, label: 'Permission Check' },
    { icon: Lock, label: 'Execution' },
  ]

  return (
    <section className="py-24 sm:py-32 bg-surface border-t border-line relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight mb-4">
          Enterprise-grade security built-in.
        </h2>
        <p className="max-w-2xl mx-auto text-lg text-ink-muted leading-relaxed mb-16">
          Your GitHub authorization tokens are encrypted at rest. RepoPilot operates a strict permission model with read-only modes and mandatory approval gates.
        </p>

        <div className="max-w-4xl mx-auto bg-ground border border-line rounded-xl p-8 shadow-card overflow-x-auto">
          <div className="flex items-center justify-between min-w-[600px] gap-4">
            {steps.map((step, i) => (
              <div key={i} className="flex items-center">
                <motion.div 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.2 }}
                  viewport={{ once: true }}
                  className="flex flex-col items-center gap-3"
                >
                  <div className="w-16 h-16 rounded-full bg-surface border border-line flex items-center justify-center text-primary shadow-inner">
                    <step.icon className="w-6 h-6" />
                  </div>
                  <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider text-center max-w-[100px]">
                    {step.label}
                  </div>
                </motion.div>
                
                {i < steps.length - 1 && (
                  <motion.div 
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    transition={{ delay: i * 0.2 + 0.1, duration: 0.3 }}
                    viewport={{ once: true }}
                    className="w-16 mx-4 h-px bg-line relative origin-left"
                  >
                    <ArrowRight className="w-4 h-4 text-line-strong absolute -right-2 -top-2 bg-ground" />
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
